import { create } from 'zustand'

import { Setters, State } from './types'
import { initialState } from './state'

export const usePointStore = create<State & Setters>((set) => ({
  ...initialState,

  setTileQueryParams: (tileQueryParams: string) =>
    set(() => ({ tileQueryParams })),
  setPointsSvgContainer: (pointsSvgContainer: any | undefined) =>
    set(() => ({ pointsSvgContainer })),

  setIsEnablePropertiesPoints: (isEnablePropertiesPoints: boolean) =>
    set(() => ({ isEnablePropertiesPoints })),

  addLoadedPoints: (loadedPoints) =>
    set((state) => {
      const newLoadedPoints = [...state.loadedPoints, loadedPoints]
      return { loadedPoints: newLoadedPoints }
    }),
  clearLoadedPoints: () => set(() => ({ loadedPoints: [] })),

  addLoadedStackeds: (loadedStackeds) =>
    set((state) => {
      const newLoadedStackeds = [...state.loadedStackeds, loadedStackeds]
      return { loadedStackeds: newLoadedStackeds }
    }),
  clearLoadedStackeds: () => set(() => ({ loadedStackeds: [] })),

  addLoadedClusters: (loadedClusters) =>
    set((state) => {
      const newLoadedClusters = [...state.loadedClusters, loadedClusters]
      return { loadedClusters: newLoadedClusters }
    }),
  clearLoadedClusters: () => set(() => ({ loadedClusters: [] })),
  setHoveredOffMarketPoint: (hoveredOffMarketPoint) =>
    set(() => ({ hoveredOffMarketPoint })),
}))
